import { render, staticRenderFns } from "./lizis.vue?vue&type=template&id=691372de&scoped=true&"
import script from "./lizis.vue?vue&type=script&lang=js&"
export * from "./lizis.vue?vue&type=script&lang=js&"
import style0 from "./lizis.vue?vue&type=style&index=0&id=691372de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691372de",
  null
  
)

export default component.exports